import * as Yup from 'yup'

import { getTranslate } from '../../../localization'

export const loginValidationSchema = Yup.object({
  email: Yup.string()
    .email('Please enter a valid email')
    .required('This field is required'),
  password: Yup.string().required(getTranslate('This field is required'))
})
